import { useContext } from 'react';
import type { PowattorneyServiceApi } from '@pa-api/pa-logic-crudl-document';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function usePowAttorneyApiClient(): PowattorneyServiceApi {
  const { powAttorneyApi } = useContext(ApiContext);

  return powAttorneyApi;
}
